import { MinzeElement, Attrs } from 'minze'

export interface LvcHandDrawnInput {
  label: string
  value: string
  readOnly: boolean
}

export class LvcHandDrawnInput extends MinzeElement {
  attrs: Attrs = [
    ['label', null],
    ['value', null],
    ['readOnly', false],
  ]
  static observedAttributes = ['label', 'value', 'readOnly']

  html = () => `
    <div class="hand-drawn-input">
      <lvc-hand-drawn-box variant="button1" hoverBgFromColor="#DCFFD7" hoverBgToColor="#89F27A">
        <div class="hand-drawn-input-content">
          <slot name="icon"></slot>
          <div class="hand-drawn-input-text">
            <div class="hand-drawn-input-label">${this.label}</div>
            ${
              this.readOnly
                ? /* html */ `
              ${
                this.value
                  ? /* html */ `
                <div class="hand-drawn-input-value">${this.value}</div>
              `
                  : ''
              }
            `
                : /* html */ `
              <!-- <input class="hand-drawn-input-input" type="text" value="${this.value ? this.value : ''}" /> -->
            `
            }
          </div>
          <div class="hand-drawn-input-action">
            <slot name="action"></slot>
          </div>
        </div>
      </lvc-hand-drawn-box>
    </div>
  `

  css = () => `
    :host {}

    .hand-drawn-input {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
      font-size: 1em;
      text-decoration: none;
    }

    .hand-drawn-input-content {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding: 10px;
      color: #1E007D;
    }

    ::slotted([slot=icon]) {
      height: 40px;
    }

    .hand-drawn-input-label {
      margin-bottom: 10px;
      font-size: 0.750em;
      font-weight: 500;
      line-height: 120%;
    }

    .hand-drawn-input-value {
      font-size: 1em;
      font-weight: 800;
      line-height: 120%;
      text-transform: uppercase;
      word-wrap: break-word;
      overflow-wrap: break-word;
      word-break: break-word;
      white-space: normal;

    }

    lvc-arrow-right-icon {
      transform: rotate(-35deg)
    }

    /* @media only screen and (max-width: 991px) {
      .hand-drawn-input-action {
        display: none;
      }
    } */

    @media only screen and (min-width: 992px) {
      .hand-drawn-input-content {
        flex-direction: row;
        align-items: center;
        gap: 20px;
        padding: 10px 20px;
      }

      .hand-drawn-input-label {
        margin-bottom: 5px;
        font-size: 0.875em;
      }

      .hand-drawn-input-value {
        font-size: 1.375em;
        line-height: 120%;
      }

      .hand-drawn-input-action {
        margin-left: auto;
      }
    }
  `
}
